import styled, { css } from 'styled-components';

export const INVListContainer = styled.div`
  position: static;
  width: 100%;
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const INVCard = styled.div`
  position: static;
  width: 100%;
  height: 143px;
  margin-bottom: 8px;
  background: #ffffff;
  border: 1px solid #ebebec;
  box-sizing: border-box;
  padding: 16px 5% 16px 5%;
  border-radius: 12px;
  flex-direction: column;
  justify-content: flex-start;
`;

export const InvDetails = styled.span<{
  width:number;
}>`
  height: 17px;
  width: ${props=>props.width}%;
  font-family: Nunito;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 140%;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  color: #6d6d6d;
`;
export const InvCompany = styled.span`
  margin-top: 17px;
  height: 19px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: #000000;
`;

export const InvWorth = styled.span`
  position: static;
  height: 21px;
  width: 30%;
  margin-top: 18px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  font-family: Nunito;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.02em;
  color: #1e1e1e;
`;

export const InvGSTIN = styled(InvCompany)`
  margin-top: 4px;
  height: 15px;
  font-family: Nunito;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 140%;
  color: #6d6d6d;
`;

export const ShareBtn = styled.button`
  padding: 0px;
  margin-top: 18px;
  width: 59px;
  border: none;
  height: 21px;
  outline: none;
  display: flex;
  flexdirection: 'row';
  align-items: center;
  background: #ffff;
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: #454ade;
`;

export const ButtonImg = styled.img`
  height: 32px;
  width: 32px;
  margin-left: -10px;
`;

export const DnldBtn = styled(ShareBtn)<{ disabled?: boolean }>`
  margin-left: 14px;
  width: 88px;
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `}
`;
